import { Component } from '@angular/core';

@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html'
})

export class SimulationComponent {

  goToTop(): void {
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/simulation/simulation.component.ts